/*
 * Created by mvasim on 12/9/17.
 */

/*
 * tableAction ->
 *  'ADD' -> Add Action
 *  'REFRESH' -> Refresh Action
 *
 */

import { Subject } from 'rxjs';
import { FnGridActionSetup } from './fn-grid-action.setup';
import { FnGridRowAction } from './fn-grid-row.action';
import { FN_GRID_EXPORT_TYPE } from './fn-grid.constant';

export interface FnGridActionParmas {
	action: string;
	data: any;
}
export interface FnGridRowHeader {
	rowName: string;
	isHidden:boolean;
}
export class FnGridConfig {
	static defalutSortClass = ' fa-sort';
	static defaultSortValue = 0; // -1 = desc , 1 = asc
	static defaultIsColSort = true;

	uniqueKey?: any;
	tableClass?: string;
	pagination? = true;
	isRowGrouping? = false;
	hideAction?: boolean;
	footerLeftText ?: string;
	footerCenterText?: string;
	rowGroupKey?: string;
	hideRptDownload?:boolean;

	rowActionArray?: Array<FnGridRowAction>;

	// Grid All Action Setups
	gridActionSetupArray: Array<FnGridActionSetup>;

	defaultSortKey?: string;
	hidePagination?: boolean;
	isSelectable?: boolean;// not in use
	pageSize?: number;

	reRenderAfterUpdate?: boolean; //
	enableDisplayOrder?: boolean; // should be false once sorting enable
	displayOrderKey?: string; // default display order key

	enableMultiSelect?: boolean;

	uiGridAction?: Subject<FnGridActionParmas>;

	// to be merege with global config as wel
	exportConfigArray?: Array<FnGridExportConfig>; // TO be Array
	reportName?: string;
}

export class FnGridExportConfig {
	isHidden?: boolean;
	type: FN_GRID_EXPORT_TYPE; // FnTableExportType.{type}
}

/**
 * TBD; Table Action types 
        1: Inline Delete
        2: Edit Modal 
        3: View Modal
        4: Route 
        5: Custome-Action :- POST 
 */

// export class FnGridAction {
// 	typeID: string; //  ADD DELETE UPDATE CUSTOM
// 	actionID: string;
// 	isConditinal?: boolean;
// 	conditionalKey?: any; // row.something., header.something, globalCnf.something
// 	isRedirectAction?: boolean;
// 	redirectUrl?: string; // if isRedirectAction true
// }

// export class FnGridRowAction {
// 	icon: string;
// 	styleClass?: string;
// 	displayOrder: number;
// 	fnTableActionID: string; // FnTableAction.typeID,
// 	mdlComponent?: string;
// 	isDirectAction?: boolean; // like delete
// }

/* // Table row
export class FnGridRow {
	isSelected: boolean;
    data: object; // object.compareTo-- we have the row for comparision
    uid:any;
    rowIndex:number;
}
 */
